module.exports = __webpack_public_path__ + "img/yuebao.a1bb8d1c.svg";